import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'country-flag-renderer',
  templateUrl: './country-flag-renderer.component.html',
  styleUrls: ['./country-flag-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CountryFlagRendererComponent implements ICellRendererAngularComp {
  public readonly emptyFlagSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACw=';
  params: ICellRendererParams;
  public country : string;
  public imgSrc : string = '';
  constructor() {}

  initilize(params: ICellRendererParams) {
    this.params = params;
    this.country = (params?.data?.Country || '').toString().trim();
    this.imgSrc = (params?.data?.CountryFlagUrl || '').toString().trim();
  }

  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
